export interface IXmTrackingCounts {
    kitsRequested: number,
    pendingDonorCenter: number,
    pendingRecipientCenter: number,
    completed: number,
    cancelled: number
}